document.addEventListener('DOMContentLoaded', function() {
  const video = document.querySelector('.custom-parallax');
  const siteContent = document.querySelector('#paralax-effect');
  const announcementBar = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');
  // const sectionOverlay = document.querySelector('.section-overlay');

  const announcementHeight = announcementBar.offsetHeight;
  const headerHeight = header.offsetHeight;
  const viewportHeight = window.innerHeight;


  const marginTop = viewportHeight - announcementHeight - headerHeight;
  const menuDrawerHeight = announcementBar.getBoundingClientRect().top;

  // console.log("This is marginTop",marginTop);
  // console.log("This is headerHeight",headerHeight);
  // console.log("This is announcementHeight",announcementHeight);

//const initialMargin = 96; // in vh

//   const getInitialMargin = () => {
//   if (window.innerWidth <= 768) {
//     return 85; // new value for small screens
//   }

//   return 96; // default value
// };

// const initialMargin = getInitialMargin();


  if (video && siteContent) {
    // Set initial video styles
    video.style.position = 'fixed';
    video.style.top = '0';
    video.style.left = '0';
    video.style.zIndex = '-2';
    // video.style.height = `${initialMargin}vh`; //for custom heights
    video.style.height = `${marginTop}px`; //for fixed show ONLY header
    // if (sectionOverlay) {
    //   sectionOverlay.style.height = `${marginTop}px`; //for fixed show ONLY header
    // }
    video.style.width = '100vw';
    video.style.objectFit = 'cover'; // Optional for nicer scaling

    // Set the initial margin on the main content

    // siteContent.style.marginTop = initialMargin + 'vh'; //for custom heights
    siteContent.style.marginTop = `${marginTop}px`; //for fixed to show ONLY header

    let ticking = false;
    const windowHeight = window.innerHeight;

    // function updateMargin() {
    //   const scrollY = window.scrollY;
    //   let newMargin = initialMargin - (scrollY / windowHeight * 100);
    //   newMargin = Math.max(0, Math.min(newMargin, initialMargin));
    //   siteContent.style.marginTop = newMargin + 'vh';
    //   ticking = false;
    // }

    function updateMargin() {
    const scrollY = window.scrollY;
    let newMargin = marginTop - (scrollY / windowHeight * marginTop);
    newMargin = Math.max(0, Math.min(newMargin, marginTop));
    siteContent.style.marginTop = newMargin + 'px';
    ticking = false;
  }


    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateMargin);
        ticking = true;
      }
    });


    // This code is for header-drawer alignment
    const menuDrawer = document.querySelector('.menu-drawer');
    menuDrawer.classList.add('header-paralax-menu-drawer');
    menuDrawer.style.height = `${marginTop}px`;

  if (!menuDrawer) return;

  window.addEventListener('scroll', function () {
    const scrollPosition = window.scrollY;

    if (scrollPosition > 0) {
       menuDrawer.classList.remove('header-paralax-menu-drawer');
       menuDrawer.style.height = ``;
    } else {
      menuDrawer.classList.add('header-paralax-menu-drawer');
      menuDrawer.style.height = marginTop + 'px';

    }
  });

  }
});
